export { default } from "./Heading"
